<!-- eslint-disable prettier/prettier -->
<template>
  <table>
    <tr>
      <td v-for="(file, i) in arrFiles" :key="file.file_link || file.file_name || i" class="custom-i">

        <v-btn
          v-if="isAdmin"
          class="close-button custom-close btn-pd center-icon"
          variant="text"
          @click="removeFile(file.id, 'condition')"
          title="Удалить файл"
        >
          <v-icon>ti-close</v-icon>
        </v-btn>

        <a :href="rootUrl + getFileHref(file)" target="_blank" :title="getFileName(file)">
          <i :class="fileIcon(file.file_type)" />
          <span>{{ getFileName(file) }}</span>
        </a>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "filesComponent",
  props: [
    "isAdmin",
    "arrFiles"
  ],

  data() {
    return {
      rootUrl: process.env.VUE_APP_FILE_URL,
    };
  },

  methods: {
    getFileHref(file) {
      return (file && (file.filePath || file.file_link || file.file_path)) ? (file.filePath || file.file_link || file.file_path) : "#";
    },

    getFileName(file) {
      return (file && (file.realFileName || file.file_name || file.title || file.name)) ? (file.realFileName || file.file_name || file.title || file.name) : "file";
    },
    
    fileIcon(ext) {
      const map = {
        doc: "fa fa-file-word-o",
        docx: "fa fa-file-word-o",
        xls: "fa fa-file-excel-o",
        xlsx: "fa fa-file-excel-o",
        jpg: "fa fa-file-image-o",
        jpeg: "fa fa-file-image-o",
        png: "fa fa-file-image-o",
        pdf: "fa fa-file-pdf-o",
      };
      return map[ext] || "fa fa-file-o";
    },

    removeFile(fileId, attachmentType) {
      this.$emit("removeFile", {
        fileId: fileId,
        attachmentType: attachmentType
      });
    },

  },
};
</script>

<style scoped>
.center-icon {
  right: 7px !important;
  top: 2px !important;
}
.center-icon i::before {
  margin-top: 0;
}
</style>